import React, { useEffect, useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput'

import UiDropDownList from '../../../../_uiComponents/telerikComponents/UiDropDownList';
import {
    UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import { MainLeftTitle } from "../../../../_uiComponents/WrapperComponents";
import { UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import { useDispatch } from 'react-redux';
import { participantGetApplicationRequest, participantGetAreasRequest, participantGetDealersRequest, participantGetRolesRequest, participantSaveNewParticipantRequest , participantGetTlcCustomersRequest} from '../../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { UiSwitch } from '../../../../_uiComponents/telerikComponents/UiSwitch';


export default function AddParticipants(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { applications, areaList, jobRoleList, dealerList, tlcCustomers } = useSelector((state) => ({
        applications: state?.participantsManagement?.application,
        areaList: state?.participantsManagement?.areaList,
        jobRoleList: state?.participantsManagement?.jobRoleList,
        dealerList: state?.participantsManagement?.dealerList,
        tlcCustomers: state?.participantsManagement.tlcCustomerList,
    }));

    const [applicationType, setApplicationType] = useState(1);
    const [isChecked, setIschecked] = useState(true);
    const [areaType, setAreaType] = useState(null);
    const [jobRoleType, setJobRoleType] = useState(null);
    const [dealerType, setDealerType] = useState(null);
    const [tlcCustomerType, setTlcCustomerType] = useState(null);

    console.log(applicationType)

    useEffect(() => {
        dispatch(participantGetApplicationRequest());
    }, [dispatch]);

    useEffect(() => {
        dispatch(participantGetAreasRequest({ applicationId: applicationType }));
        dispatch(participantGetDealersRequest({ applicationId: 1 }));
        dispatch(participantGetRolesRequest({ applicationId: applicationType }));
        dispatch(participantGetTlcCustomersRequest({})); 
    }, [applicationType, dispatch]);

    useEffect(() => {
    console.log('Full state:', applications, areaList, jobRoleList, dealerList, tlcCustomers);
}, [applications, areaList, jobRoleList, dealerList, tlcCustomers]);


    console.log('TLC Customers:', tlcCustomers);


    const emailRegex = new RegExp(/\S+@\S+\.\S+/);
    const firstNameValidator = value => value ? '' : 'First Name is required.';
    const lastNameValidator = value => value ? '' : 'Last Name is required.';
    const applicationsValidator = value => value ? '' : 'Application is required.';
    const jobRoleValidator = value => value ? '' : 'Job Role is required.';
    const dealerValidator = value => value ? '' : 'Dealer is required.';
    const areaValidator = value => value ? '' : 'Area is required.';
    const emailValidator = value => !value ? 'Email is required.' : emailRegex.test(value) ? '' : 'Email is not in a valid format.';

// Update the handleSubmit function to include a callback or redirection after success

const handleSubmit = dataItem => {
    // Convert all ID values to numbers and handle null values properly
    const payload = {
        ApplicationId: Number(applicationType),
        DealershipId: dealerType === null ? (dealerList.length > 0 ? Number(dealerList[0].id) : null) : Number(dealerType),
        AreaId: areaType === null ? (areaList.length > 0 ? Number(areaList[0].id) : null) : Number(areaType),
        JobRoleId: jobRoleType === null ? (jobRoleList.length > 0 ? Number(jobRoleList[0].id) : null) : Number(jobRoleType),
        Email: dataItem.email,
        FirstName: dataItem.firstName,
        LastName: dataItem.lastName,
        Active: isChecked,
        TlcCustomerId: jobRoleType === 21 ? Number(tlcCustomerType) : 1
    }
    
    console.log('Submitting participant with payload:', payload);
    dispatch(participantSaveNewParticipantRequest(payload));
    
    // Note: success toast will be handled by the message middleware
    // after successful response from the server
}
    console.log('jobRoleType', jobRoleType);
    

    return (
        <>
            <MainLeftTitle title="Add Participants" />
            <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                    <Grid container spacing={2}>
                        <div className="sba-input-areas-wr">

                            {applications.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                    <Field name={'applications'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={applications.filter((app) => app.id !== 0).map((app) => ({
                                            value: app.id.toString(),
                                            label: app.name,
                                        }))}
                                        label={'Applications'}
                                        validator={applicationsValidator}
                                        value={applicationType}
                                        onChange={(e) => setApplicationType(e.value?.value)} />


                                    {/* <Field name={'applications'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={applications.filter((app) => app.id !== 0).map((app) => ({
                                            value: app.id.toString(),
                                            label: app.name,
                                        }))}
                                        label={'Applications'}
                                        validator={applicationsValidator}
                                        value={applicationType}
                                        handleChange={setApplicationType} /> */}
                                </Grid>
                            )}
                            {jobRoleList.length > 0 &&
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'jobRole'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={jobRoleList.map((jobRole) => ({
                                            value: jobRole.id,
                                            label: jobRole.name,
                                        }))}
                                        label={'Job Role'}
                                        validator={jobRoleValidator}
                                        value={jobRoleType}
                                        onChange={(e) => setJobRoleType(e.value?.value)} />
                                </Grid>
                            }
                            {(jobRoleType !== null && jobRoleType !== 20 && jobRoleType !==24 && jobRoleType !==22 ) && dealerList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'dealer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={dealerList.map((dealer) => ({
                                            value: dealer.id.toString(),
                                            label: dealer.name,
                                        }))}
                                        label={'Dealer'}
                                        validator={dealerValidator}
                                        value={dealerType}
                                        onChange={(e) => setDealerType(e.value?.value)} />
                                </Grid>
                            )}

                            {(jobRoleType !== null && (jobRoleType === 20||jobRoleType === 22)) && areaList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'area'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={areaList.map((area) => ({
                                            value: area.id.toString(),
                                            label: area.name,
                                        }))}
                                        label={'Area'}
                                        validator={areaValidator}
                                        value={areaType}
                                        onChange={(e) => setAreaType(e.value?.value)} />
                                </Grid>
                            )}
                            {(jobRoleType !== null && jobRoleType === 21) && tlcCustomers && tlcCustomers.length > 0 && (
                                        <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                            <Field name={'tlcCustomer'}
                                                component={UiDropDownList}
                                                labelClassName={'k-form-label'}
                                                data={tlcCustomers.map((customer) => ({
                                                    value: customer.id.toString(),
                                                    label: customer.name,
                                                }))}
                                                label={'TLC Customer'}
                                                validator={value => value ? '' : 'TLC Customer is required.'}
                                                value={dealerType}
                                                 onChange={(e) => setTlcCustomerType(e.value?.value)}  
                                            />
                                        </Grid>
)}

                            {/* {(jobRoleType !== null && jobRoleType === 21) && tlcCustomers.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'customer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={tlcCustomers.map((customer) => ({
                                            value: customer.id.toString(),
                                            label: customer.name,
                                        }))}
                                        label={'Customer'}
                                        // validator={areaValidator}
                                        value={areaType}
                                        // onChange={(e) => setAreaType(e.value?.value)} 
                                        />
                                </Grid>
                            )} */}

                            {/* {jobRoleList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                <Field
                                    name="jobRole"
                                    component={(fieldRenderProps) => (
                                        <UiDropDownList
                                        {...fieldRenderProps} // Includes the validation and other Field props
                                        data={jobRoleList.map((jobRole) => ({
                                            value: jobRole.id,
                                            label: jobRole.name,
                                        }))}
                                        value={jobRoleType}
                                        label="Job Role"
                                        handleChange={(selectedValue) => setJobRoleType(selectedValue)}
                                        validator={jobRoleValidator}
                                        />
                                    )}
                                    validator={jobRoleValidator}
                                    />
                                </Grid>
                            )}

                            {(jobRoleType !== null && jobRoleType?.value !== 20) && dealerList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                    <Field name={'dealer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={dealerList.map((dealer) => ({
                                            value: dealer.id.toString(),
                                            label: dealer.name,
                                        }))}
                                        label={'Dealer'}
                                        validator={dealerValidator}
                                        value={dealerType}
                                        handleChange={setDealerType} />

                                </Grid>
                            )}

                            {(jobRoleType !== null && jobRoleType?.value === 20) && areaList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'area'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={areaList.map((area) => ({
                                            value: area.id.toString(),
                                            label: area.name,
                                        }))}
                                        label={'Area'}
                                        validator={areaValidator}
                                        value={areaType}
                                        handleChange={areaType} />

                                </Grid>
                            )} */}

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'email'}
                                    validator={emailValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Email'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'firstName'}
                                    validator={firstNameValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'First name'} />
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'lastName'}
                                    component={UiInput}
                                    validator={lastNameValidator}
                                    labelClassName={'k-form-label'}
                                    label={'Last name'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'status'}
                                    component={UiSwitch}
                                    labelClassName={'k-form-label'}
                                    handleChange={setIschecked}
                                    isChecked={isChecked}
                                    label={'Status'} />
                            </Grid>

                            <Grid item xs={12}>
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ width: "100%", mt: 1.5 }}
                                >
                                    <UiBackButton size="small" onClick={() => navigate(-1)} />
                                    <div className="sbt-right-action-btn-wr">
                                        <UiButton
                                            name="Cancel"
                                            variant="outlined"
                                            size="small"
                                            onClick={formRenderProps.onFormReset}
                                        />
                                        <UiButton
                                            name="Add"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />

                                    </div>
                                </Stack>
                            </Grid>
                        </div>
                    </Grid>
                }
            />

        </>
    );
}

